// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2U5Qc","selected":"Chip_selected__UMEKv"};